<template>
  <div class="pa-2">
    <v-row class="ma-0">
      <v-col cols="12" sm="3">
        <label class="label">{{ $t('Instituição') }}</label>
        <v-autocomplete
          hide-details="auto"
          v-model="filter.institutionIds"
          :items="institutions"
          item-value="id"
          :rules="[(v) => v.length <= 10 || 'Máximo de 10 instituições']"
          item-text="name"
          :loading="institutionLoading"
          outlined
          class="primary-input"
          multiple
          chips
          clearable
          small-chips
          @keyup.enter="filterData"
          @change=";(filter.unidadeId = null), getUnidades()"
          append-icon="mdi-chevron-down"
        >
          <template v-slot:selection="{ attrs, item, selected, index }">
            <v-chip
              v-if="index === 0"
              v-bind="attrs"
              :input-value="selected"
              color="#BBCF20"
              text-color="#fff"
              small
            >
              {{ item.name }}
            </v-chip>
            <span
              v-if="index === 1"
              class="grey--text text-caption"
              style="font-size: 0.8rem"
            >
              ( +{{ filter.institutionIds.length - 1 }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3">
        <label class="label">{{ $t('Unidade') }}</label>
        <v-autocomplete
          hide-details="auto"
          v-model="filter.unidadeId"
          :items="unidades"
          item-value="id"
          item-text="name"
          :loading="unidadeLoading"
          clearable
          outlined
          class="primary-input"
          @keyup.enter="filterData"
          append-icon="mdi-chevron-down"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3">
        <label class="label">{{ $t('Data fechamento') }} (inicial)</label>
        <v-menu
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              placeholder="00/00/0000"
              :value="formatDate(filter.startDate)"
              hide-details="auto"
              clearable
              outlined
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              @keyup.enter="filterData"
              autocomplete="off"
              class="primary-input mr-2"
            ></v-text-field>
          </template>
          <v-date-picker locale="pt" v-model="filter.startDate" no-title>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="3">
        <label class="label">{{ $t('Data fechamento') }} (final)</label>
        <v-menu
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              placeholder="00/00/0000"
              :value="formatDate(filter.endDate)"
              hide-details="auto"
              clearable
              outlined
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              @keyup.enter="filterData"
              autocomplete="off"
              class="primary-input mr-2"
            ></v-text-field>
          </template>
          <v-date-picker locale="pt" v-model="filter.endDate" no-title>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col class="d-flex justify-end" cols="12">
        <v-btn class="primary-button ma-1" depressed @click="exportExcel">
          {{ $t('Exportar excel') }}
        </v-btn>

        <v-btn class="primary-button ma-1" depressed @click="filterData">
          {{ $t('Filtrar') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      class="main-table"
      hide-default-footer
      hide-default-header
      :items-per-page="filter.pageSize"
      :header-props="headerProps"
      mobile-breakpoint="0"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.model`]="{ item }">
        {{
          item.model.replaceAll(' ', '')
            ? item.model
            : $t('Modelo não cadastrado')
        }}
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="pager.totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import FormatDate from '../../../../Utils/FormatDate'

export default {
  name: 'Manufacturer',

  data() {
    return {
      loading: false,
      sizes: [10, 30, 90, 180],
      pager: {},
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'model',
        },
        {
          text: 'Fabricante',
          align: 'center',
          value: 'manufacturer',
        },
        {
          text: 'Equipamento padrão',
          align: 'center',
          value: 'standardEquipmentName',
        },
        {
          text: 'Num. de equipamentos',
          align: 'center',
          value: 'equipNum',
        },
        {
          text: 'Num. O.S. de falha intrínsica fechadas',
          align: 'center',
          value: 'osNum',
        },
      ],
      items: [],
      page: 1,
      pageSize: 10,
      filter: {
        institutionIds: [],
        unidadeId: null,
        page: 1,
        pageSize: 10,
      },
      headerProps: {
        sortByText: 'Ordenar por',
      },
      apiService: new ApiService(),
      institutionLoading: false,
      unidadeLoading: false,
      institutions: [],
      unidades: [],
    }
  },

  created() {
    const instId = JSON.parse(localStorage.getItem('institution')).id
    this.filter.institutionIds = [instId]

    this.getInstitutions()
    this.getUnidades()
  },

  methods: {
    formatDate(date) {
      return FormatDate.dateTime(date)
    },

    filterData() {
      this.filter.page = 1
      this.page = 1
      this.getData()
    },

    exportExcel() {
      this.apiService
        .post('bigdata/model-manufacturer/excel', this.filter)
        .then((response) => {
          var excelResult = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = excelResult
          link.setAttribute('download', 'modelo-fabricante.xlsx')
          document.body.appendChild(link)
          link.click()
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/listuser')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch(() => (this.institutionLoading = false))
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .post(`bigdata/unidade`, this.filter.institutionIds)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    getData() {
      if (this.filter.institutionIds.length > 10) {
        this.$toast.warning('Máximo de 10 instituições por filtro!')
        return
      }

      this.apiService
        .post('bigdata/model-manufacturer', this.filter)
        .then((response) => {
          this.items = response.content.objects
          this.pager = response.content.pager
        })
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.getData()
    },
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.getData()
    },
  },
}
</script>

<style></style>
